import ThirdPartyPaymentOptions from "./ThirdPartyPaymentOptions";

export default ThirdPartyPaymentOptions;



// WEBPACK FOOTER //
// ./src/apps/payment/components/ThirdPartyPaymentOptions/index.js